import axios from 'axios';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

export function useDefaultLogoIcons() {
  const [logo, setLogo] = useState('');
  const brandModel = useSelector(
    (state: any) => state.config?.data?.frame?.model
  );
  const baseURLs = useSelector(
    (state: any) =>
      state.config?.baseURLs?.assetsCDN ||
      state.workflow.flowDefiningAttributes?.assetsCDN
  );
  const getFrameCode = (frameModel: string) => {
    return frameModel?.substring(0, 3);
  };
  const getDefaultLogo = async (code: string, baseURLs: string) => {
    const url = baseURLs + '/extra/image/rxc/icons/logo/model2logo.json';
    try {
      const response = await axios.get(url);
      const brand = response.data[code];
      if (brand) {
        setLogo(baseURLs + '/extra/image/rxc/icons/logo/' + brand + '.png');
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const frameCode = getFrameCode(brandModel);
    getDefaultLogo(frameCode, baseURLs);
  }, [brandModel, baseURLs]);

  return logo;
}
